// @flow

import _ from "lodash";
import moment from "moment";
import * as React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";

import correctness from "../../utils/correctness";
import type { UserTask } from "../../data/user-results";

import "./ResultsTable.css";

function formatConfidence(task: UserTask, resultIndex: number, hasObjectiveAnswers: boolean) {
  if (!task.results || task.results.length <= resultIndex) {
    return "n/a";
  }
  const result = task.results[resultIndex];
  if (result.kind === "timeout") {
    return <span className={`ResultsTable-Timeout`}>timeout</span>;
  }
  const confidence = result.confidence;
  const answer = task.answer;
  if (hasObjectiveAnswers) {
    return (
      <span
        className={`ResultsTable-Confidence-${correctness.string(
          confidence,
          answer
        )}`}
      >
        {confidence}% {correctness.symbol(confidence, answer)}
      </span>
    );
  } else {
    return (
      <span>
        {confidence}%
      </span>
    );
  }
}

function columns(hasObjectiveAnswers: boolean) {
  const middleColumn = !hasObjectiveAnswers ? [] :
  [
    {
      Header: "Answer",
      accessor: x => (x.answer ? "true" : "false"),
      id: "answer",
      width: 80,
    }
  ]

  return [
    {
      Header: "Question",
      accessor: "question"
    },
    {
      Header: "Your responses",
      columns: [
        {
          Header: "First",
          accessor: x => formatConfidence(x, 0, hasObjectiveAnswers),
          id: "firstResponse",
          width: 80
        },
        {
          Header: "Second",
          accessor: x => formatConfidence(x, 1, hasObjectiveAnswers),
          id: "secondResponse",
          width: 80
        },
        {
          Header: "Third",
          accessor: x => formatConfidence(x, 2, hasObjectiveAnswers),
          id: "thirdResponse",
          width: 80
        }
      ]
    },
    ...middleColumn,
    {
      Header: "Answered at",
      accessor: x =>
        moment
          .utc(x.results[0].createdAt)
          .local()
          .format("YYYY-MM-DD HH:mm"),
      id: "createdAt",
      width: 150
    },
    {
      Header: "Total time",
      accessor: x => `${_.last(x.results).secondsElapsed}s`,
      id: "totalSecondsElapsed",
      width: 100
    }
  ];
}

type ResultsTableProps = {
  data: Array<UserTask>,
  hasObjectiveAnswers: boolean
};

const ResultsTable = (props: ResultsTableProps) => (
  <ReactTable
    className="ResultsTable"
    data={props.data}
    columns={columns(props.hasObjectiveAnswers)}
    minRows={0}
    showPagination={false}
    defaultPageSize={1000000}
    defaultSorted={[
      {
        id: "createdAt",
        desc: true
      }
    ]}
  />
);

export default ResultsTable;



// WEBPACK FOOTER //
// ./src/components/ResultsTable/ResultsTable.js